const CHUNK_SIZE = 0x8000;

export const convertFileToBase64 = async (file: File): Promise<string> => {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';

  for (let offset = 0; offset < bytes.length; offset += CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + CHUNK_SIZE));
  }

  const mimeType = file.type === '' ? 'application/octet-stream' : file.type;

  return `data:${mimeType};base64,${btoa(binary)}`;
};
